<template>
  <div ref="home" class="home">
    <main-notice
      v-if="openPopup"
      :src="popupList[0]"
      @close="openPopup = false"
      @noMore="
        openPopup = false;
        $store.dispatch('popup/updateMain', popupList[0]._id);
      "
    />
    <Section1 />
    <Section2 />
    <Section3 />
    <Section4 />
    <Section5 />
    <Section6 />
    <Section7 />
    <Section8 />
    <AppBanner />
  </div>
</template>

<script>
import mainNotice from "@/components/modal/mainNotice/layout";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import AppBanner from "@/components/common/AppBanner";

import { useObserver } from "@/helpers/observer";

export default {
  metaInfo: {
    title: "디버, 나에게 Fit한 배송",
    titleTemplate: null
  },
  components: {
    mainNotice,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Section7,
    Section8,
    AppBanner
  },
  methods: {
    getNoticeModal() {
      this.$store
        .dispatch("notice/getMainPopup")
        .then((res) => {
          this.popupList = res.popups;
          if (!this.popupList.length) return;
          this.$store
            .dispatch("popup/checkMain", this.popupList[0]._id)
            .then((res) => {
              if (res === "show") this.openPopup = true;
              else this.openPopup = false;
            });
        })
        .catch((e) => {});
    }
  },
  data() {
    return {
      openPopup: false,
      popupList: []
    };
  },

  mounted() {
    this.getNoticeModal();
    const home = this.$refs.home;
    const { intersectionObserver, intersectionObserverBounce } = useObserver();
    intersectionObserver(home, ".observer-selector");
  }
};
</script>

<style scoped src="./home.common.css"></style>
<style>
html {
  color: var(--gray-content);
}
</style>
